module.exports = __webpack_public_path__ + "static/media/facebook.4fb2d1bf.svg";